var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
import './InputFile';
let InputImage = class InputImage extends LitElement {
    constructor() {
        super(...arguments);
        this.selectedImageUrl = null;
    }
    render() {
        return html `
      <div class="container">
        <input-file
          label="${msg('Choose an image', { id: 'form.image.chooseImage', desc: 'Choose image button' })}"
          fileTypes=${JSON.stringify(['image/*'])}
          @file-selected=${this.handleFileSelected}
        ></input-file>
        ${this.selectedImageUrl
            ? html `<img class="image-preview" src="${this.selectedImageUrl}" alt="${msg('Image preview', { id: 'form.image.preview', desc: 'Image preview alt text' })}" />`
            : html `<div class="placeholder">${msg('No image selected', { id: 'form.image.noImage', desc: 'No image selected message' })}</div>`}
      </div>
    `;
    }
    handleFileSelected(e) {
        const files = e.detail;
        if (files.length > 0) {
            const file = files[0];
            if (file) {
                this.selectedImageUrl = URL.createObjectURL(file);
            }
            else {
                this.selectedImageUrl = null;
            }
        }
        else {
            this.selectedImageUrl = null;
        }
        this.dispatchEvent(new CustomEvent('image-selected', { detail: files, bubbles: true, composed: true }));
    }
};
InputImage.styles = css `
    :host {
      display: block;
      font-family: inherit;
      height: 150px;
      width: 100%;
    }

    .container {
      display: flex;
      align-items: stretch; /* Assure que les enfants occupent toute la hauteur */
      gap: 16px;
      width: 100%;
      height: 150px;
    }

    input-file {
      flex: 1;
      min-width: 0; /* Permet au flex item de rétrécir en dessous de sa taille de contenu */
      overflow: hidden; /* Cache le contenu qui déborde */
      height: 100%;
      display: flex;
    }

    .image-preview {
      height: 100%;
      max-width: 50%;
      object-fit: contain;
      border: 1px solid #ddd;
      border-radius: 4px;
      background: #f9f9f9;
    }

    .placeholder {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 100%;
      max-width: 50%;
      width: 100%;
      border: 1px solid #ddd;
      border-radius: 4px;
      background: #f0f0f0;
      color: #aaa;
      font-size: 14px;
      font-style: italic;
    }
  `;
__decorate([
    state()
], InputImage.prototype, "selectedImageUrl", void 0);
InputImage = __decorate([
    localized(),
    customElement('input-image')
], InputImage);
export { InputImage };
//# sourceMappingURL=InputImage.js.map